export * from './WindowProvider';
//# sourceMappingURL=index.js.map